// Modal.js
import React, { useState } from 'react';
import './github.css'; // Import your modal styles (create this CSS file)
import Button from "../GitHubComponents/Button"

const Modal = ({handleClose, inputMetaData, onSubmit, header, inputHeader, submitBtnTxt }) => {
    const [inputData, setInputData] = useState([]) 
    const handleChange = (e) => {
        const { value } = e.target;
        setInputData(oldArray => [...oldArray, value] );
    };
    return (
        <div className="modal display-block">
            <div className="modal-content">
                <div className="modal-head">
                    <h5>{header}</h5>
                    <button onClick={handleClose}>Close</button>
                </div>
                <div className="modal-body">
                    <h6>{inputHeader}</h6>
                    { inputMetaData && inputMetaData.map((data, i) => (
                        <div className="radio-selector" key={i}>
                            <input type="radio" name={data.name} value={data.name} onChange={handleChange}/>
                            <div className="radio-info">
                                <h5>{data.name}</h5>
                                <p>{data.description}</p>
                            </div>
                        </div>
                    ))}

                </div>
                <div className="modal-foot">
                    <Button text={submitBtnTxt} style={{ color: "#c62828", width: "414px" }} hoverColor={"#a40e26"} onClick={()=>{onSubmit(inputData)}}/>
                </div>
            </div>
        </div>
    );
};

export default Modal;
